export default {
      id: "er-usage",
      viewBox: "0 0 640 480",
      url: __webpack_public_path__ + "assets/flags-sprite.svg#er",
      toString: function () {
        return this.url;
      }
    }